import Amplify, {Auth, Hub} from 'aws-amplify';
import awsConfig from '../../aws-exports';
Auth.configure(awsConfig);
export class CognitoAuthGateway {
    async signOut() {
        await Auth.signOut({global: true})
    }
}
